import { getAppUrl } from './appUrlUtils';
import ViewModel from './viewmodel';

import { getTopWindow, getParentWindow, getLocation } from './window';
import { getGlobalStorage } from './storage';

const insideAppKey = 'insidetab_app_appcode';

//获取微应用的document
export function getDocument(runContext) {
    if(runContext?.appContainer?.firstElementChild){
        return runContext.appContainer.firstElementChild;
    }
    let pageid = getAppUrl().pageid;
    let qiankunDocument = document.querySelector(`#microApp-${pageid}`);
    if (window.__QIANKUN_RUNCONTEXT) { // 业务代码使用
        return window.__QIANKUN_RUNCONTEXT.container?.firstElementChild;
    } else if (qiankunDocument) { //platform工程base中使用
        let container = qiankunDocument.querySelector(`[data-name^="microApp-${pageid}"]`);
        return container || qiankunDocument;
    }
    return document.body;
}

export function getInsideAppCode() {
    let pageid = getAppUrl().pageid;
    let qiankunDocument = document.querySelector(`#microApp-${pageid}`);
    if (qiankunDocument) {//乾坤模式
        let appContext = ViewModel.getData(insideAppKey);
        console.log("getInsideAppCode---appContext, pageid", appContext, pageid);
        if (appContext && appContext[pageid]) {
            return appContext[pageid];
        }
    }
    return null;
}

export function setInsideAppCode(runContext) {
    let appContext = ViewModel.getData(insideAppKey);
    let pageid = getAppUrl().pageid;
    if (!appContext) {
        appContext = { [pageid]: runContext.appInfo.c };
    }
    appContext[pageid] = runContext.appInfo.c;
    ViewModel.setData(insideAppKey, appContext);
    console.log("setInsideAppCode---appContext, pageid", appContext, pageid);
}
// if (document.visibilityState === "visible")   业务写法修改
// 是否乾坤框架应该都使用 data.visibilityState

window.__globalEvent = {
    beforeunload: [],
    visibilitychange: [],
    message: [],
};

const insideProxyEvents = ['beforeunload', 'visibilitychange'];

window.__globalEventHandler = event => {
    let eventName = event.type;
    window.__globalEvent[eventName].forEach(handler => {
        if (eventName == 'beforeunload') {
            //e.returnValue = '' //表示能关闭
            //return ''//表示不能关闭
            //if (Object.prototype.toString.call(handler) === '[object AsyncFunction]'){
            (async () => {
                let msg;
                try {
                    msg = await handler(event);
                } catch (e) {
                    msg = handler(event);
                }

                if (typeof msg === 'undefined') {
                    // event.preventDefault();//这行会导致谷歌浏览器在返回undefined的时候也有提示
                    // event.returnValue = ""; // 返回空字符串在低版本浏览器无法关闭
                } else {
                    event.returnValue = msg;
                }
            })();
            // }else{
            //     let msg = handler(event);
            //     if(typeof msg === 'undefined'){
            //         // event.preventDefault();//这行会导致谷歌浏览器在返回undefined的时候也有提示
            //         event.returnValue = "";
            //     }else{
            //         event.returnValue = msg;
            //     }
            // }
            // [], null, undefied, '', 

            // 兼容IE8和Firefox 4之前的版本
            // if(msg){
            //     event = event || window.event;
            //     if (event) {
            //         
            //     }
            // }
            //Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
            // return msg;        

        } else if (eventName == 'visibilitychange') {
            //增加visibilityState参数
            event.visibilityState = document.visibilityState;
            event.isInsideTab = !!isInsideTab();
            handler(event);
        } else {
            handler(event);
        }
    });
};

function isInsideTab(){
    return !!JSON.parse(getGlobalStorage('localStorage', 'INSIDE_TAB'));
}

for (let pop in window.__globalEvent) {
    window.addEventListener(pop, window.__globalEventHandler);
}

//TopWindow.__micro__globalEvent = { beforeunload: { [appKey]: [eventLister] };

export function addEventListener(eventName, eventLister) {
    if (isInsideTab() && insideProxyEvents.includes(eventName)) {
        let appKey = __getMicroUrlKey(),
            topWindow = getTopWindow();

        if(!topWindow.__micro__globalEvent){
            topWindow.__micro__globalEvent = new topWindow.Object();
        }
        let eventMap = topWindow.__micro__globalEvent;
        if(!eventMap[eventName]){
            eventMap[eventName] = new topWindow.Object();
        }
        if(!eventMap[eventName][appKey]){
            eventMap[eventName][appKey] = new topWindow.Array();
        }
        eventMap[eventName][appKey]?.push(eventLister);
    } else {
        //window.addEventListener(eventName, eventLister, type);
        if (!window.__globalEvent[eventName]) {
            window.__globalEvent[eventName] = [];
        }
        window.__globalEvent[eventName]?.push(eventLister);
    }
}

export function removeEventListener(eventName, eventLister) {
    if (isInsideTab() && insideProxyEvents.includes(eventName)) {
        let appKey = __getMicroUrlKey();
        let eventMap = getTopWindow().__micro__globalEvent;
        if(eventMap && eventMap[eventName] && eventMap[eventName][appKey]){
            let index = eventMap[eventName][appKey]?.indexOf(eventLister); 
            if (index > -1) {
                eventMap[eventName][appKey]?.splice(index, 1); 
            }
        }
    } else {
        //window.removeEventListener(eventName, eventLister, type);
        if (window.__globalEvent[eventName]) {
            let index = window.__globalEvent[eventName].indexOf(eventLister); // 找到要删除的元素的索引
            if (index > -1) {
                window.__globalEvent[eventName].splice(index, 1); // 删除该元素
            }
        }
    }
}

//获取乾坤popContainer
export function getPopContainer(container) {
    if (container) {
        if (typeof container === "function") {
            let popContainer = container();
            return popContainer?.querySelector('#app') || popContainer;
        } else {
            return container.querySelector('#app') || container;
        }
    } else {
        return document.body;
    }
}

export function getMicroHistory(runContext) {
    let history = null;
    runContext = getRunContext(runContext);
    if (runContext) {
        history = runContext.history;
    }
    return history;
}

//获取微应用的location
export function getMicroLocation(runContext) {
    let history = getMicroHistory(runContext);
    if (history) {
        if (history.location) {
            return history.location;
        }
    }
    return getLocation(window);
}

export function isQiankunEnv(runContext) {
    if (runContext || window.__QIANKUN_RUNCONTEXT) {
        return true;
    }
    return false;
}

export function getRunContext(runContext) {
    if (!runContext && window.__QIANKUN_RUNCONTEXT) {
        runContext = window.__QIANKUN_RUNCONTEXT.runContext;
    }
    return runContext;
}

function getHistory(context) {
    return context.history || { location:{} };
}

//获取微应用的ifr
export function getMicroHref(runContext) {
    let ifrHref = getLocation(window).href;
    if (getRunContext(runContext)) {
        runContext = getRunContext(runContext);
        let ifr = runContext.appInfo.ifr;
        let { location: { pathname, search } } = getHistory(runContext);
        let ifrHash = pathname + search;
        if (ifr.startsWith('../../../../')) {
            ifrHref = ifr.match(/\.\.\/\.\.\/\.\.\/\.\.\/(.*?)\.html/)[1] + '.html' + '#' + ifrHash;
        } else {
            ifrHref = ifr.split('.html')[0] + '.html' + '#' + ifrHash;
        }
    }
    return ifrHref;
}

//获取微应用上下文，如应用编码和页面编码等

//判断当前微应用是否是乾坤模式，
//如当前应用是乾坤模式，从sessionStorage里面获取；

//若当前应用不是乾坤模式，而window.parent是乾坤模式，则从window.parent的history里面取c参数------后面业务改造后都从history中取
//若当前应用不是乾坤模式，window.parent也不是乾坤模式，则从sessionStorage中取 ------后面业务改造后都从history中取
export function getMicroContext(runContext) {
    let isQiankun = isQiankunEnv(runContext);
    runContext = getRunContext(runContext);
    //console.log("获取系统参数上下文---", 'isQiankun', isQiankun, 'window.parent.__QIANKUN_RUNCONTEX', window.parent.__QIANKUN_RUNCONTEX );
    //修改业务代码后，props在这里传过来获取appcode
    if (isQiankun) {//当前应用是乾坤模式，从window上获取，若window上不存在，从prop上获取；
        //此处应该自己解析sessionStorage中的参数，因为pushTo或者跳转后不会修改appInfo
        // let contextObj = {};
        // let pageStore = getAppUrl().pageurl;
        // if (pageStore && pageStore.includes('&')) {
        //     pageStore.split('&').map(e => {
        //         let item = e.split("=");
        //         contextObj[item[0]] = decodeURIComponent(decodeURIComponent(item[1]));
        //     });
        // }
        // return { ...runContext.appInfo, ...contextObj };
        return runContext.appInfo;
    } else if (!isQiankun) { // 非乾坤模式
        //乾坤加载的业务页面，业务页面又使用iframe加载单据，此处为单据获取
        let params = getLocation(window).hash;
        if (params.includes("?")) {
            let search = params.split('?')[1];
            let urlKey = '';
            if (search.includes('&')) {
                let systemContext = search.split('&').find(e => e.includes('urlKey='));
                if (systemContext) {
                    urlKey = decodeURIComponent(systemContext.split('=')[1]);
                }
            } else if (search.includes('urlKey=')) {
                urlKey = decodeURIComponent(search.split('=')[1]);
            }
            if (urlKey) {
                let context = getAppUrl(urlKey).pageurl;
                if (context) {
                    // let cPrams = context.split('&');

                    // //系统参数优先获取_iframe_system_context中的c p n
                    // let index = cPrams.findIndex(e => e.includes('_iframe_system_context='));
                    // if(index!=-1){
                    //     context = decodeURIComponent(cPrams[index].split('=')[1]);
                    // }
                    //若没有_iframe_system_context，再获取c p n 等
                    let contextMap = {};
                    context.split('&').forEach(e => {
                        let [key, value] = e.split('=');
                        if (key && value) {
                            contextMap[key] = decodeURIComponent(decodeURIComponent(value));
                        }
                    });
                    return contextMap;
                }
            }

        }
        return null;
    }
    // else if (!isQiankun && window.parent.__QIANKUN_RUNCONTEXT) { //乾坤模式下，业务单据内嵌iframe的场景使用
    //     if (window.parent.__QIANKUN_RUNCONTEXT.runContext) {//乾坤模式
    //         let history = window.parent.__QIANKUN_RUNCONTEXT.runContext.history;
    //         let microContext = {};
    //         if (history) {
    //             history.location.search.split('&').forEach((item => {
    //                 microContext[item.split("=")[0]] = item.split("=")[1];
    //             }));
    //             return microContext;
    //         }

    //     }
    // }
    return null;
}

export function getPlatform() {
    return { ...window['nc-lightapp-front'] };
}

export function closeTab() {
    let workbenchWindow = getTopWindow();
    if (isInsideTab() && typeof workbenchWindow?.microAppApi?.close === "function") {
        let appKey = __getMicroUrlKey();
        workbenchWindow.microAppApi.close(appKey);
    } else if (typeof top.close === "function") {
        top.close(); //关闭页签只能取top
    }
}

export function reloadTab() {
    getLocation(window).reload(); 
}

//globalDataPool
//key由领域保证全局唯一
export function setGlobalData(key, data) {
    //let runContext = getRunContext();
    let appKey = __getMicroUrlKey();
    let workbenchWindow = getTopWindow();
    if (workbenchWindow?.globalDataPool) {
        if (appKey) {
            if (!workbenchWindow.globalDataPool[appKey]) {
                workbenchWindow.globalDataPool[appKey] = {};
            }
            workbenchWindow.globalDataPool[appKey][key] = data;
        } else {
            workbenchWindow.globalDataPool[key] = data;
        }
    }
}
export function getGlobalData(key) {
    //let runContext = getRunContext();
    let appKey = __getMicroUrlKey();
    let workbenchWindow = getTopWindow();
    if (workbenchWindow?.globalDataPool) {
        if (appKey) {
            let tabData = workbenchWindow.globalDataPool[appKey];
            if (tabData) {
                return tabData[key];
            }
        } else {
            return workbenchWindow.globalDataPool[key];
        }
    }
}
export function removeGlobalData(key) {
    // let runContext = getRunContext();
    let appKey = __getMicroUrlKey();
    let workbenchWindow = getTopWindow();
    if (workbenchWindow?.globalDataPool) {
        if (appKey) {
            let tabData = workbenchWindow.globalDataPool[appKey];
            if (tabData && tabData[key]) {
                delete tabData[key];
            }
        } else {
            delete workbenchWindow.globalDataPool[key];
        }

    }
}

function __getMicroUrlKey(){
    let urlKeyMatchs = getLocation(window).href.match(/urlKey=([^&$]+)/);
    let urlKey = '';
    if(urlKeyMatchs && urlKeyMatchs[1]){
        urlKey = urlKeyMatchs[1];
    }
    return urlKey;
}
//更新页签名称
export function updateTabTitle(title) {
    let workbenchWindow = getTopWindow();
    if (isInsideTab() && typeof workbenchWindow.updateMicroOnMain === "function") {
        let appKey = __getMicroUrlKey();
        workbenchWindow.updateMicroOnMain({ type: 'tabTitle', data: title }, appKey);
    } else {
        top.document.title = title;
    }
}

//获取containerSelector
export function getContainerSelector() {
    // let runContext = getRunContext();
    // if (runContext?.appContainer) {
    //     return runContext.appContainer;
    // } else {
    //     return "#app";
    // }
    return '#app';
}

//工作台封装给业务节点的api，用于更新子应用
export function updateMicroOnMain(data) {
    let workbenchWindow = getTopWindow();
    if (typeof workbenchWindow.updateMicroOnMain === "function") {
        let appKey = __getMicroUrlKey();
        workbenchWindow.updateMicroOnMain(data, appKey);
    }
}

export function getUnProxyWindow() {
    let runContext = getRunContext();
    let workbenchWindow = getParentWindow(window);
    if (runContext) {//内部页签
        return workbenchWindow;
    }

    return window;
}
